import React from "react";
import "../../../assets/css/welcome.css";
import loginLogo from "../../../assets/img/login-logo2.svg";
import logoHover from "../../../assets/img/login-logohover.svg";
import logoHover2 from '../../../assets/img/login-logohover2.svg';
const SignUpHeader = ({userName}) => {
  return (
    <div className="welcome-page">
      <div className="header-top-sec">
      <div className="container">
      <div className="header-top">
        <div className="login-logo">
          <a className="happyLogo-cover">
            <img
              src={loginLogo}
              alt={loginLogo}
              className="happy-logo"
            />
            <img
              src={logoHover}
              alt={logoHover}
              className="happy-logo2"
            />
            <img src={logoHover2} alt="Happy Ending" className="happy-logo2 hover-happy-logo2" />
             
          </a>
          <p class="login-box-msg">Happy Ending</p>
        </div>
        <p className="user-name">Hi {userName}, Welcome</p>
      </div>
      </div>
      </div>
    
    
    </div>
  );
};

export default SignUpHeader;
